import { qs } from 'modules/dom';

const paginationHandlers = new Map();
let listenerBound = false;

export function pageFromHref(href) {
  const match = href.match(/(?:\?|&(?:amp;)?)(?:tracker_)?page=(\d+)/);
  return match ? match[1] : '1';
}

export function bindAjaxPagination(containerSelector, buildUrl) {
  paginationHandlers.set(containerSelector, buildUrl);
  if (listenerBound) return;
  listenerBound = true;

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('.pagination a');
    if (!link) return;

    let matchedSelector;
    let buildUrlForContainer;

    for (const [selector, urlBuilder] of paginationHandlers.entries()) {
      if (link.closest(selector)) {
        matchedSelector = selector;
        buildUrlForContainer = urlBuilder;
        break;
      }
    }

    if (!matchedSelector) return;

    event.preventDefault();
    const container = qs(matchedSelector);
    if (!container) return;

    const href = link.getAttribute('href');
    const url = buildUrlForContainer ? buildUrlForContainer(href, container) : href;
    const response = await fetch(url, {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    });

    if (!response.ok) return;
    container.innerHTML = await response.text();
  });
}
